import React from "react";
import { useTranslation } from "react-i18next";
import { InputAutoresize } from "../../../common/components/form";

export default function InputMenuLinkTitle(props) {
    const { t } = useTranslation();

    const {
        name,
        set,
        variables: { MenuLinkTitle },
        placeholder,
    } = props;

    const _MenuLinkTitle = (() => ({
        ...MenuLinkTitle,
        [name]: (MenuLinkTitle || {})[name] || "",
    }))();

    function onChange(event) {
        set({
            MenuLinkTitle: {
                ..._MenuLinkTitle,
                [name]: event.target.value,
            },
        });
    }

    return (
        <>
            <p>{t("WizardMenuLink")}</p>

            <InputAutoresize
                className="margin-top-20"
                onChange={onChange}
                trimOnBlur
                value={_MenuLinkTitle[name] || ""}
                placeholder={placeholder || t(name)}
            />
        </>
    );
}
